import { Navigate, useParams } from 'react-router-dom';
import { AGENT_SETUP_BASE } from '../constants/setupRoadmapSteps';
import AdminTest from '../pages/admin/Test';
import AdminLanding from '../pages/admin/AdminLanding';
import AgentManagement from '../pages/admin/AgentManagement';
import AgentEdit from '../pages/admin/AgentEdit';
import AgentSetupLayout from '../pages/admin/AgentSetupLayout';
import AgentSetupIndex from '../pages/admin/AgentSetupIndex';
import AgentChatPage from '../pages/admin/AgentChatPage';
import CollectionsManagement from '../pages/admin/CollectionsManagement';
import DocumentsManagement from '../pages/admin/DocumentsManagement';
import WorkflowManagement from '../pages/admin/WorkflowManagement';
import WorkflowEdit from '../pages/admin/WorkflowEdit';
import WorkflowCreate from '../pages/admin/WorkflowCreate';
import SetupRoadmap from '../pages/admin/SetupRoadmap';
import InitialConfig, { Loader as InitialConfigLoader } from '../pages/admin/InitialConfig';
import NetworkConnectivity from '../pages/admin/NetworkConnectivity';
import CilogonSetup from '../pages/admin/CilogonSetup';
import UsersManagement from '../pages/admin/UsersManagement';

import AdminLayout from '../layouts/Admin';
import AccessControlLayout from '../layouts/AccessControlLayout';
import ErrorPage from '../pages/ErrorPage';

function RedirectToSetupAgentEdit() {
    const { agentId } = useParams();
    return <Navigate to={`${AGENT_SETUP_BASE}/manage/${agentId}`} replace />;
}
function RedirectToSetupWorkflowEdit() {
    const { workflowId } = useParams();
    return <Navigate to={`${AGENT_SETUP_BASE}/workflows/${workflowId}`} replace />;
}

const AdminRoutes = {
    element: <AccessControlLayout isAdmin={true} useBaseLayout={true}/>,
    errorElement: <ErrorPage/>,
    children:[{
        element: <AdminLayout/>,
        children:[
            {
                path: '/admin',
                element: <AdminLanding/>
            },
            {
                path: '/admin/setup',
                element: <SetupRoadmap/>
            },
            {
                path: '/admin/setup/initial',
                element: <InitialConfig/>,
                loader: InitialConfigLoader
            },
            {
                path: '/admin/setup/network',
                element: <NetworkConnectivity/>
            },
            {
                path: '/admin/setup/cilogon',
                element: <CilogonSetup/>
            },
            {
                path: '/admin/setup/agents',
                element: <AgentSetupLayout/>,
                children: [
                    { index: true, element: <AgentSetupIndex/> },
                    { path: 'manage', element: <AgentManagement/> },
                    { path: 'manage/:agentId', element: <AgentEdit/> },
                    { path: 'collections', element: <CollectionsManagement/> },
                    { path: 'documents', element: <DocumentsManagement/> },
                    { path: 'chat', element: <AgentChatPage/> },
                    { path: 'workflows', element: <WorkflowManagement/> },
                    { path: 'workflows/create', element: <WorkflowCreate/> },
                    { path: 'workflows/:workflowId', element: <WorkflowEdit/> },
                ]
            },
            {
                path: '/admin/test',
                element: <AdminTest/>
            },
            {
                path: '/admin/users',
                element: <UsersManagement/>
            },
            {
                path: '/admin/agents',
                element: <Navigate to={AGENT_SETUP_BASE} replace />
            },
            /* Legacy flat routes: redirect to nested setup/agents paths so old links still work */
            {
                path: '/admin/agents/manage',
                element: <Navigate to={`${AGENT_SETUP_BASE}/manage`} replace />
            },
            {
                path: '/admin/agents/manage/:agentId',
                element: <RedirectToSetupAgentEdit />
            },
            {
                path: '/admin/agents/collections',
                element: <Navigate to={`${AGENT_SETUP_BASE}/collections`} replace />
            },
            {
                path: '/admin/agents/documents',
                element: <Navigate to={`${AGENT_SETUP_BASE}/documents`} replace />
            },
            {
                path: '/admin/workflows',
                element: <Navigate to={`${AGENT_SETUP_BASE}/workflows`} replace />
            },
            {
                path: '/admin/workflows/create',
                element: <Navigate to={`${AGENT_SETUP_BASE}/workflows/create`} replace />
            },
            {
                path: '/admin/workflows/:workflowId',
                element: <RedirectToSetupWorkflowEdit />
            },
        ]
    }]
    
}

export default AdminRoutes
